<template>
    <transition name="collapse">
        <section :aside="asideDirection" :level="level > 0 ? level : false" :direction="direction" :class="{expanded: mainExpanded}">
            <header v-if="heading || subheading || header || subheader" @click="headerClick">
                <div v-if="heading || subheading || subheader">
                    <template v-if="heading">
                        <h2 v-if="level <= 1" :class="headingClass" @click="headingClick">{{heading}}</h2> 
                        <h4 v-else-if="level <= 2" :class="headingClass" @click="headingClick">{{heading}}</h4> 
                        <h5 v-else :class="headingClass" @click="headingClick">{{heading}}</h5>
                    </template>
                    <p v-if="subheading">{{subheading}}</p>
                    <div v-if="subheader">
                        <slot name="subheader"></slot>
                    </div>
                </div>
                <slot name="header"></slot>
            </header>
            <aside v-if="aside" :class="{expanded: asideExpanded}">
                <header @click="asideExpanded = !asideExpanded;" v-if="asideHeading">
                    {{asideHeading}}
                </header>
                <article>
                    <slot name="aside"></slot>
                </article>
            </aside>

            <div v-if="direction === 'column'">
                <slot></slot>
            </div>
            <slot v-else-if="columns === 1"></slot>
            <column-group v-else :class="columnClass">
                <div v-if="col1">
                    <slot name="column-1"></slot>
                </div>
                <div v-if="col2">
                    <slot name="column-2"></slot>
                </div>
                <div v-if="col3">
                    <slot name="column-3"></slot>
                </div>
                <div v-if="col4">
                    <slot name="column-4"></slot>
                </div>
            </column-group>
            <message v-if="error" :message="error" type="warning" />
            <footer v-if="footer">
                <slot name="footer"></slot>
            </footer>
        </section>
    </transition>
</template>

<script>
export default {
    computed: {
        aside() {
            return !!this.$slots.aside;
        },
        asideDirection() {
            return this.aside ? 
                this.asideRight ? 'right' : 'left' :
                false;
        },
        header() {
            return !!this.$slots.header;
        },
        subheader() {
            return !!this.$slots.subheader;
        },
        footer() {
            return !!this.$slots.footer;
        },
        col1(){
            // TODO, this does not get re-calculated if it was empty to begin with.
            return !!this.$slots['column-1'];
        },
        col2(){
            return !!this.$slots['column-2'];
        },
        col3(){
            return !!this.$slots['column-3'];
        },
        col4(){
            return !!this.$slots['column-4'];
        },
    },
    props: {
        heading: {
            type: String,
            default: ''
        },
        headingClass: {
            type: [String,Object,Array],
            default: undefined
        },
        headingClick: {
            type: Function,
            default() {}
        },
        subheading: {
            type: String,
            default: ''
        },
        asideHeading: {
            type: String,
            default: ''
        },
        asideRight: {
            type: Boolean,
            default: false
        },
        direction: {
            type: String,
            default: null
        },
        level: {
            type: [Number,String],
            default: 1,
            coerce: val => parseInt(val)
        },
        collapsible: {
            type: [Boolean,String],
            default: false, 
            coerce: val => typeof val === 'string' ? val === 'true' : val
        },
        columns: {
            type: [Number,String],
            default: 1,
            coerce: val => parseInt(val)
        },
        columnClass: {
            type: String,
            default: ''
        },
        error: {
            type: String,
            default: null
        }
    },
    methods: {
        headerClick(){
            if(this.collapsible){
                this.mainExpanded = !this.mainExpanded;
            }
        },
    },
    data() {
		return {
            asideExpanded: false,
            mainExpanded: false
        };
    },
    components: {
		Message: () => import('../items/message.vue'),
	},
}
</script>